import { render } from "./RacerItem.vue?vue&type=template&id=37df28e7&scoped=true"
import script from "./RacerItem.vue?vue&type=script&lang=js"
export * from "./RacerItem.vue?vue&type=script&lang=js"

import "./RacerItem.vue?vue&type=style&index=0&id=37df28e7&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37df28e7"]])

export default __exports__